import { ownListeningProfileQueryParams } from './ownListeningProfile';
import { dedupeSharetribeQuery, retryOn429 } from './sharetribeSafeQuery';

const ownListeningProfileQueryParamsAnyState = () => {
  const { states, ...rest } = ownListeningProfileQueryParams();
  return { ...rest, page: 1, perPage: 20 };
};

const listFromQuery = response => {
  const raw = response?.data?.data;
  if (Array.isArray(raw)) {
    return raw;
  }
  return raw ? [raw] : [];
};

/**
 * Own Listening listings. A 429 or failed query returns `{ listings: null }`
 * — never an empty array, which the UI used to read as “not set up”.
 *
 * @param {Object} sdk
 * @param {Object} [options]
 * @param {number} [options.waitMs] 429 retry wait (tests can pass 0)
 * @returns {Promise<{ listings: Array|null, error: Object|null }>}
 */
export const queryOwnListeningProfiles = async (sdk, options = {}) => {
  if (!sdk?.ownListings?.query) {
    return { listings: null, error: new Error('ownListings.query is not available') };
  }
  const waitMs = options.waitMs;
  const runQuery = params =>
    retryOn429(() => sdk.ownListings.query(params), { retries: 2, waitMs }).then(listFromQuery);

  const load = async () => {
    try {
      let listings = await runQuery(ownListeningProfileQueryParams());
      if (listings.length === 0) {
        // states= filter has come back empty on TEST while the listing exists.
        listings = await runQuery(ownListeningProfileQueryParamsAnyState());
      }
      return { listings, error: null };
    } catch (first) {
      try {
        const listings = await runQuery(ownListeningProfileQueryParamsAnyState());
        return { listings, error: null };
      } catch (second) {
        return { listings: null, error: second };
      }
    }
  };

  if (options.skipCache) {
    return load();
  }
  return dedupeSharetribeQuery('own-listening-profiles-hours', load, { ttlMs: options.ttlMs });
};
